module.exports = __webpack_public_path__ + "media/bootstrap-icons/reception-3-61834aae.svg";